import { render, staticRenderFns } from "./SubscriptionsTable.vue?vue&type=template&id=e2d3dc1a&scoped=true&"
import script from "./SubscriptionsTable.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionsTable.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionsTable.vue?vue&type=style&index=0&id=e2d3dc1a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d3dc1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
